<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{label}}</v-card-title>

        <v-card-text>

            <v-text-field
                label="Keyword"
                v-model="raw_keyword"
                autofocus
                v-on:input="update"
                :hint="hint"
                style="margin-bottom: 15px;"
                autocomplete="off"
            />

            <p>Keywords are case insensitive.  RedChirp always displays keywords in upper case.</p>
            <p>You can't have multiple auto responses with the same keyword.</p>  
            <p>Keywords may *not* contain spaces.  The only allowed characters are letters, numbers -, #, @, $, *.  Keywords must be 64 characters or less.</p>
            <p>We <b>strongly</b> suggest you use something that is unlikely to come up in other conversation.  For example, use SALE47 instead of SALE</p>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            {{action_label}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default 
{

    props: {
        label: {
            type: String,
            default: function() { return 'Create Keyword'; },
        },

        action_label: {
            type: String,
            default: function() { return 'Ok'; },
        },

        organization_id: {
            type: String,
            default: function() { return ''; },
        },
    },

    data() {
        return {
            dialog: false,
            raw_keyword: null,
            normalized_keyword: null,
            is_valid: false,
            hint: null,
        }
    },

    methods: {

        showDialog(keyword)
        {
            this.raw_keyword = keyword;
            this.dialog = true;
        },

        update: _.debounce(function()
        {
            this.$rc.rest(
                'NORMALIZE-KEYWORD: /api/v1/keyword-auto-response',
            
                {
                    'organization_id' : this.organization_id,
                    'raw_keyword' : this.raw_keyword
                },
            
                (data) => {
                    
                    this.hint = null;

                    if ( !data.is_valid_keyword )
                    {
                        if ( this.raw_keyword == null || this.raw_keyword.trim().length == 0 ) this.hint = null;
                        else this.hint = 'Not a valid keyword';
                    }

                    if ( data.settings_exist_for_keyword )
                    {
                        this.hint = "This keyword already exists";
                    }

                    this.is_valid = data.is_valid_keyword && !data.settings_exist_for_keyword;
                    this.normalized_keyword = data.normalized_keyword;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        }, 751),

        onOk()
        {
            this.dialog = false;
            
            if ( this.normalized_keyword != null )
                this.$emit('ok', this.normalized_keyword);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>